import * as types from './types';

export default {
  [types.MUTATE_SNACKBAR]: (state, snack) => {
    state.snack = snack;
  },
};
